var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECEFF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_20935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.25C18 12.8358 18.3358 12.5 18.75 12.5H21.25C21.6642 12.5 22 12.8358 22 13.25C22 13.6642 21.6642 14 21.25 14H18.75C18.3358 14 18 13.6642 18 13.25Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.25C13 12.8358 13.3358 12.5 13.75 12.5H16.25C16.6642 12.5 17 12.8358 17 13.25C17 13.6642 16.6642 14 16.25 14H13.75C13.3358 14 13 13.6642 13 13.25Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.75C18 15.3358 18.3358 15 18.75 15H21.25C21.6642 15 22 15.3358 22 15.75C22 16.1642 21.6642 16.5 21.25 16.5H18.75C18.3358 16.5 18 16.1642 18 15.75Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15.75C13 15.3358 13.3358 15 13.75 15H16.25C16.6642 15 17 15.3358 17 15.75C17 16.1642 16.6642 16.5 16.25 16.5H13.75C13.3358 16.5 13 16.1642 13 15.75Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.9492C18 10.535 18.3358 10.1992 18.75 10.1992H21.25C21.6642 10.1992 22 10.535 22 10.9492C22 11.3634 21.6642 11.6992 21.25 11.6992H18.75C18.3358 11.6992 18 11.3634 18 10.9492Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 6.55477C23.25 6.37285 23.0619 6.25184 22.8963 6.32727L11.8963 11.3391C11.8072 11.3797 11.75 11.4686 11.75 11.5666V17.5H10.25V11.5666C10.25 10.8809 10.6505 10.2584 11.2744 9.9741L22.2744 4.96227C23.4332 4.43429 24.75 5.28134 24.75 6.55477V25.5H23.25V6.55477Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 18.2506C8.75 18.0933 8.89353 17.9751 9.04791 18.0052L20.0479 20.1531C20.1653 20.1761 20.25 20.2789 20.25 20.3985V25.5H21.75V20.3985C21.75 19.5613 21.1571 18.8414 20.3354 18.6809L9.33538 16.533C8.25471 16.322 7.25 17.1495 7.25 18.2506V25.5H8.75V18.2506Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 26.25C6 25.8358 6.33579 25.5 6.75 25.5H25.25C25.6642 25.5 26 25.8358 26 26.25C26 26.6642 25.6642 27 25.25 27H6.75C6.33579 27 6 26.6642 6 26.25Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 23C12.25 22.0335 13.0335 21.25 14 21.25H15C15.9665 21.25 16.75 22.0335 16.75 23V25.5H15.25V23C15.25 22.8619 15.1381 22.75 15 22.75H14C13.8619 22.75 13.75 22.8619 13.75 23V25.5H12.25V23Z",
    fill: "#B0BEC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_20935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultWorkspace);
export default __webpack_public_path__ + "static/media/DefaultWorkspace.cc10ced2767580adceed7dc930dae611.svg";
export { ForwardRef as ReactComponent };